import anime from 'animejs/lib/anime.es.js';


document.addEventListener('DOMContentLoaded', function () {
    faqToggle();
    buttonToggleActive();
});

const faqToggle = () => {
    const faqs = document.querySelectorAll(".faq__single");
    faqs.forEach(faq => {
        faq.addEventListener("click", function () {
            const answer = this.querySelector(".faq__answer");


            if (this.classList.contains("active")) {
                anime({
                    targets: this.querySelector(".faq__answer"),
                    height: 0,
                    paddingTop: 0,
                    duration: 300,
                    easing: "linear"
                });
            } else {
                this.classList.add("active");
                answer.style.height = 'auto';
                let height = answer.clientHeight;
                answer.style.height = 0;
                this.classList.remove("active");

                anime({
                    targets: this.querySelector(".faq__answer"),
                    height: ["0px", height + 16],
                    paddingTop: [0, 16],
                    duration: 300,
                    easing: "linear"
                });
            }
            this.classList.toggle("active");
        });
    })
}

const buttonToggleActive = () => {
    const faqActive = document.querySelectorAll(".faq__anchor-link");
    const scrollElement = window.document.scrollingElement || window.document.body || window.document.documentElement;
    faqActive.forEach(faqActiveSingle => {
        faqActiveSingle.addEventListener("click", (e) => {
            e.preventDefault();
            const elementScrollTop = document.querySelector(faqActiveSingle.attributes.href.value);
            anime({
                targets:scrollElement,
                scrollTop: elementScrollTop.offsetTop - 32,
                duration: 500,
                easing: 'easeInOutQuad'
            });
            if (faqActiveSingle.classList.contains("active")) return;
            faqActive.forEach(faqActiveSingleInner => faqActiveSingleInner.classList.remove("active"));
            faqActiveSingle.classList.add("active");
        });
    });
}